import WordTypes from './word.types'
import api from '../../api/index.api'
import { createPagedFetchThunk } from '../utils/createPagedFetchThunk'

export const onGetWords = createPagedFetchThunk({
	type: WordTypes.GET_WORDS,
	fetchApi: page => api.wordApi.getWordWithPaging(page),
})
